const copyProposalLocale = require('../copyProposal/copyProposal.i18n.json');

/*@ngInject*/
const ProposalActionUtil = function ($rootScope, $uibModal, modalUtil, loadingBarHandler, submissionConstant, actionsMediator, proposalActionsMediator, coreConstant, uiPerformanceLoggerConstant, proposalMediator, sectionType, attachmentUtil, collaborationMediator, coreMediator, umModalUtil) {

    this.i18n = {
        copyProposal: copyProposalLocale
    };

    this.copyProposal = function (submissionId, proposalId) {
        function onSuccess() {
            $rootScope.$broadcast(
                coreConstant.event.END_UI_PERFORMANCE_LOG,
                uiPerformanceLoggerConstant.COPY_PROPOSAL,
                coreConstant.uiPeformanceLogger.SUCCESS
            );
        }

        function onError() {
            $rootScope.$broadcast(
                coreConstant.event.END_UI_PERFORMANCE_LOG,
                uiPerformanceLoggerConstant.COPY_PROPOSAL,
                coreConstant.uiPeformanceLogger.FAIL
            );
        }

        const modalInstance = $uibModal.open({
            templateUrl: '/wizard/actions/copyProposal/copyProposalModal.tpl.html',
            controller: 'copyProposalModalController',
            windowClass: 'copyProposalModal',
            resolve: {
                submissionId: () => {
                    return submissionId;
                },
                proposalId: () => {
                    return proposalId;
                }
            },
            keyboard: false,
            backdrop: 'static'
        });

        modalInstance.result.then((options) => {
            let promise;
            loadingBarHandler.showLoadingBar(this.i18n.copyProposal.loading);

            $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

            $rootScope.$broadcast(
                coreConstant.event.START_UI_PERFORMANCE_LOG,
                uiPerformanceLoggerConstant.COPY_PROPOSAL,
                `proposalId=${proposalId},quotes=${options.quotes}`
            );

            promise = proposalActionsMediator.copyProposal(proposalId, options.quotes).then(onSuccess, onError).finally(() => {
                loadingBarHandler.hideLoadingBar();
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        });
    };

    this.modifyProposal = function (proposalId) {
        let promise;
        loadingBarHandler.showLoadingBar('submission.modifyingProposal');

        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

        promise = proposalActionsMediator.modifyProposal(proposalId).then(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);

            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.deleteProposal = function (submissionId, proposalId) {
        modalUtil.showConfirmationModal(submissionId, null, null/*notificationName*/, 'submission.wizard.deleteProposal', null/*performanceLoggerName*/, /*hideLoadingBar*/false, handleClose);

        function handleClose() {
            let promise = proposalActionsMediator.deleteProposal(proposalId).then(() => {
                $rootScope.$broadcast(submissionConstant.event.REDIRECT_TO_OVERVIEW);
                loadingBarHandler.hideLoadingBar();
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.beginBinding = function (submissionId, proposalId) {
        modalUtil.showProposalBindActionModal(submissionId, proposalId, 'submission.wizard.beginBinding', null/*notificationName*/, uiPerformanceLoggerConstant.BEGIN_BINDING, handleClose);

        function handleClose(proposalId, quoteIds) {
            let promise;
            $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

            promise = proposalActionsMediator.beginBinding(proposalId, quoteIds);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.declineToBindFromSent = function (submissionId, proposalId) {
        modalUtil.showProposalBindActionModal(
            submissionId,
            proposalId,
            'submission.wizard.declineToBindFromSent',
            /*notificationName*/null,
            uiPerformanceLoggerConstant.DECLINE_TO_BIND,
            handleClose);

        function handleClose(proposalId, quoteIds) {
            loadingBarHandler.hideLoadingBar();

            umModalUtil.showReasonModal(
                submissionId,
                /*quoteId*/null,
                /*notificationName*/null,
                /*reasonObject*/null,
                'submission.wizard.reasonModal.declineToBindModal',
                /*isReasonOptional*/true,
                uiPerformanceLoggerConstant.DECLINE_TO_BIND,
                handleClose);

            function handleClose(result) {
                let promise = proposalActionsMediator.declineToBindFromSent(quoteIds, result.reason, result.details);
                $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                return promise;
            }
        }
    };

    this.declineToBind = function (submissionId, proposalId) {
        umModalUtil.showReasonModal(
            submissionId,
            /*quoteId*/null,
            /*notificationName*/null,
            /*reasonObject*/null,
            'submission.wizard.reasonModal.declineToBindModal',
            /*isReasonOptional*/true,
            uiPerformanceLoggerConstant.DECLINE_TO_BIND,
            handleClose);

        function handleClose(result) {
            let promise = proposalActionsMediator.declineToBind(proposalId, result.reason, result.details);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.requestToBindFromSent = function (submissionId, proposalId) {
        modalUtil.showProposalBindActionModal(submissionId, proposalId, 'submission.wizard.requestToBind', null/*notificationName*/, uiPerformanceLoggerConstant.REQUEST_BINDING, handleClose);

        function handleClose(proposalId, quoteIds) {
            let promise;
            $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

            promise = proposalActionsMediator.requestToBindFromSent(quoteIds);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.bindProposalFromSent = function (submissionId, proposalId) {
        modalUtil.showProposalBindActionModal(submissionId, proposalId, 'submission.wizard.bindProposal', null/*notificationName*/, uiPerformanceLoggerConstant.BIND, handleClose);

        function handleClose(proposalId, quoteIds) {
            let promise;
            $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

            promise = proposalActionsMediator.bindProposal(proposalId, quoteIds);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.requestBinding = function (submissionId, proposalId) {
        modalUtil.showConfirmationModal(submissionId, null, null/*notificationName*/, 'submission.wizard.requestBindingModal', uiPerformanceLoggerConstant.REQUEST_BINDING, /*hideLoadingBar*/false, handleClose);

        function handleClose() {
            let promise;
            function onSuccess() {
                $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            }

            $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

            promise = proposalActionsMediator.requestBinding(proposalId).then(onSuccess);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.getQuotableProductTemplates = function (submissionId, proposalId) {
        const dynamicDataSetParams = {
            name: 'Quotable Products for Proposal',
            submissionUri: `com.firstbest.underwriting.submission.Submission:${submissionId}`,
            ownerUri: `com.firstbest.underwriting.proposal.Proposal:${proposalId}`
        };

        coreMediator.getDynamicDataSetItems(dynamicDataSetParams).then((response) => {
            if (response.length === 1) {
                createQuote(_.split(response[0].value, '::')[0]/*submission Id*/, proposalId, _.split(response[0].value, '::')[1]/*product Id*/);
            } else if (response.length > 1) {
                const modalInstance = $uibModal.open({
                    templateUrl: '/wizard/proposalQuotableProduct/proposalQuotableProductModal.tpl.html',
                    controller: 'proposalQuotableProductController',
                    backdrop: 'static',
                    windowClass: 'proposalQuotableProductModal',
                    resolve: {
                        options: () => {
                            return {
                                quotableProducts: response
                            };
                        }
                    }
                });

                modalInstance.result.then((options) => {
                    let promise = createQuote(options.submissionId, proposalId, options.selectedQuotableProductId);
                    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                    return promise;
                });
            }
        });
    };


    this.sendProposal = function (submissionId, proposalId) {
        proposalMediator.getSections(proposalId).then((result) => {
            const proposalSections = _.filter(result, {'type': sectionType.PROPOSAL});

            if (proposalSections.length > 1) {
                proposalMediator.findById(proposalId).then(function (proposal) {
                    const sendProposalModal = $uibModal.open({
                        templateUrl: '/wizard/actions/documentBuilder/documentBuilderModal.tpl.html',
                        controller: 'documentBuilderModalController',
                        windowClass: 'documentBuilderModalContent',
                        keyboard: false,
                        backdrop: 'static',
                        resolve: {
                            proposal: () => {
                                return proposal;
                            },
                            currentSectionType: () => {
                                return sectionType.PROPOSAL;
                            }
                        }
                    });
                    sendProposalModal.result.then(handleClose);
                });
            } else {
                modalUtil.showConfirmationModal(
                    null/*submissionId*/,
                    null/*quoteId*/,
                    'notification.sendProposal',
                    'submission.wizard.sendProposalModal',
                    null/*performanceLoggerName*/,
                    /*hideLoadingBar*/false,
                    handleClose);
            }
        });

        function handleClose() {
            let promise;
            function onSuccess() {
                $rootScope.$broadcast(
                    coreConstant.event.END_UI_PERFORMANCE_LOG,
                    uiPerformanceLoggerConstant.SEND_PROPOSAL,
                    coreConstant.uiPeformanceLogger.SUCCESS
                );
            }

            function onError() {
                $rootScope.$broadcast(
                    coreConstant.event.END_UI_PERFORMANCE_LOG,
                    uiPerformanceLoggerConstant.SEND_PROPOSAL,
                    coreConstant.uiPeformanceLogger.FAIL
                );
            }

            function onFinally() {
                loadingBarHandler.hideLoadingBar();
            }

            $rootScope.$broadcast(
                coreConstant.event.START_UI_PERFORMANCE_LOG,
                uiPerformanceLoggerConstant.SEND_PROPOSAL,
                proposalId.toString()
            );
            loadingBarHandler.showLoadingBar('submission.wizard.sendProposalModal.loadingBar');
            $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

            promise = proposalMediator.sendProposal(proposalId).then(onSuccess, onError).finally(onFinally);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.sendBinder = function (submissionId, proposalId) {
        proposalMediator.findById(proposalId).then((proposal) => {
            const sendDocumentModal = $uibModal.open({
                templateUrl: '/wizard/actions/documentBuilder/documentBuilderModal.tpl.html',
                controller: 'documentBuilderModalController',
                windowClass: 'documentBuilderModalContent',
                keyboard: false,
                backdrop: 'static',
                resolve: {
                    proposal: () => {
                        return proposal;
                    },
                    currentSectionType: () => {
                        return sectionType.BINDER;
                    },
                    proposalSections: () => {
                        return null;
                    }
                }
            });
            sendDocumentModal.result.then(handleClose);
        });

        function handleClose() {
            let promise;
            function onSuccess() {
                $rootScope.$broadcast(
                    coreConstant.event.END_UI_PERFORMANCE_LOG,
                    uiPerformanceLoggerConstant.BIND,
                    coreConstant.uiPeformanceLogger.SUCCESS
                );
                $rootScope.$broadcast(submissionConstant.event.REFRESH_CHECKLIST, submissionId);
            }

            function onError() {
                $rootScope.$broadcast(
                    coreConstant.event.END_UI_PERFORMANCE_LOG,
                    uiPerformanceLoggerConstant.BIND,
                    coreConstant.uiPeformanceLogger.FAIL
                );
            }

            function onFinally() {
                loadingBarHandler.hideLoadingBar();
            }

            $rootScope.$broadcast(
                coreConstant.event.START_UI_PERFORMANCE_LOG,
                uiPerformanceLoggerConstant.BIND,
                proposalId.toString()
            );

            loadingBarHandler.showLoadingBar('submission.wizard.bindModal.loadingBar');
            $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

            promise = proposalActionsMediator.bindProposal(proposalId).then(onSuccess, onError).finally(onFinally);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.bindProposal = function (submissionId, proposalId) {

        modalUtil.showProposalBindActionModal(submissionId, proposalId, 'submission.wizard.bindProposal', null/*notificationName*/, uiPerformanceLoggerConstant.BIND, handleClose);

        function handleClose(proposalId, quoteIds) {
            let promise;
            $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

            promise = proposalActionsMediator.bindProposal(proposalId, quoteIds);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.addProposalDocument = function (submissionId, proposalId) {
        loadingBarHandler.showLoadingBar('submission.wizard.addDocumentActionModal.loadingAttachments');

        collaborationMediator.loadSubmissionAttachments(submissionId).then((submissionAttachmentList) => {
            loadingBarHandler.hideLoadingBar();
            submissionAttachmentList = _.toArray(submissionAttachmentList);

            let modalInstance;

            if (submissionAttachmentList.length > 0) {
                modalInstance = modalUtil.showAttachmentsListModal(submissionAttachmentList);
            } else {
                modalInstance = modalUtil.showNewAttachmentModal();
            }

            modalInstance.then((data) => {
                $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
                if (attachmentUtil.isNewAttachmentObject(data)) {
                    addSectionFromFile(data, proposalId);
                } else {
                    addSectionFromDocument(data, proposalId);
                }
            });
        }).finally(() => {
            loadingBarHandler.hideLoadingBar();
        });
    };

    function addSectionFromFile(data, proposalId) {
        const attachment = data.attachment,
            file = data.file,
            payload = attachmentUtil.getAttachmentPayload(attachment);
        let promise;

        //save attachment
        loadingBarHandler.showLoadingBar('submission.wizard.addDocumentActionModal.uploading');

        promise = proposalActionsMediator.addSectionFromFile(proposalId, payload, file).finally(() => {
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    }

    function addSectionFromDocument(attachment, proposalId) {
        let promise;
        loadingBarHandler.showLoadingBar('submission.wizard.addDocumentActionModal.loadingBar');

        promise = proposalActionsMediator.addSectionFromDocument(proposalId, attachment.id, attachment.description).finally(() => {
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    }


    function createQuote(submissionId, proposalId, selectedQuotableProductId) {
        const onSuccess = function () {
                $rootScope.$broadcast(
                    coreConstant.event.END_UI_PERFORMANCE_LOG,
                    uiPerformanceLoggerConstant.CREATE_QUOTE,
                    coreConstant.uiPeformanceLogger.SUCCESS
                );

                $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            },
            onError = function () {
                $rootScope.$broadcast(
                    coreConstant.event.END_UI_PERFORMANCE_LOG,
                    uiPerformanceLoggerConstant.CREATE_QUOTE,
                    coreConstant.uiPeformanceLogger.FAIL
                );
            };
        let promise;

        $rootScope.$broadcast(
            coreConstant.event.START_UI_PERFORMANCE_LOG,
            uiPerformanceLoggerConstant.CREATE_QUOTE,
            proposalId.toString()
        );

        loadingBarHandler.showLoadingBar('submission.wizard.quotableProductModal.loadingBar');
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        promise = proposalActionsMediator.createQuote(submissionId, proposalId, selectedQuotableProductId).then(onSuccess, onError).finally(() => {
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    }

    this.addSection = function (submissionId, proposalId) {
        modalUtil.showSelectionModal(submissionId, null/*quoteId*/, proposalId, 'submission.wizard.selectionModal.addSectionModal', uiPerformanceLoggerConstant.ADD_SECTION, handleClose);

        function handleClose(sectionTemplateId) {
            let promise = proposalActionsMediator.addSection(proposalId, sectionTemplateId, sectionType.PROPOSAL);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.deleteSection = function (submissionId, proposalId) {
        modalUtil.showSelectionModal(submissionId, null/*quoteId*/, proposalId, 'submission.wizard.selectionModal.deleteSectionModal', uiPerformanceLoggerConstant.DELETE_SECTION, handleClose);

        function handleClose(sectionTemplateId) {
            let promise = proposalActionsMediator.deleteSection(sectionTemplateId, /*invalidateProposalDocument*/true);
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

    this.generateQuotes = function (submissionId, proposalId) {
        let promise;

        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.GENERATE_QUOTE, submissionId);
        loadingBarHandler.showLoadingBar('submission.wizard.generateQuotes.loadingBar');

        function onSuccess() {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_CHECKLIST, submissionId);
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.GENERATE_QUOTE, coreConstant.uiPeformanceLogger.SUCCESS);
        }

        function onError() {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.GENERATE_QUOTE, coreConstant.uiPeformanceLogger.FAIL);
        }

        function onFinally() {
            loadingBarHandler.hideLoadingBar();
        }

        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

        promise = proposalActionsMediator.generateQuotes(proposalId).then(onSuccess, onError).finally(onFinally);
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.generateBinder = function (submissionId, proposalId) {
        let promise;
        const logAction = uiPerformanceLoggerConstant.GENERATE_BINDER,
            message = proposalId.toString();

        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
        loadingBarHandler.showLoadingBar('submission.wizard.generateBinder.loadingBar');

        function onSuccess(response) {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.SUCCESS);
        }

        function onError() {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.FAIL);
        }

        function onFinally() {
            loadingBarHandler.hideLoadingBar();
        }

        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

        promise = proposalActionsMediator.generateBinder(proposalId).then(onSuccess, onError).finally(onFinally);
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

};

angular.module('gw-um-submission').service('proposalActionUtil', ProposalActionUtil);
